<div class="success-modal">
    <div class="cross-icon" (click)="closeModal()" cygovSvgIcon [svgName]="'x-icon-type2'">
    </div>
    <div class="modal-content">
        <div class="done-icon" cygovSvgIcon [svgName]="'download-complete-tick'">
        </div>
        <div class="success-message">Files uploaded Successfully!</div>
    </div>
</div>